import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';

const ArugamBay = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Arugam Bay information..." />
      
      <div ref={contentRef}>
      {/* Hero Section */}
      <section className="dest-hero">
        <img src={require('../../img/webp/arugambay1.webp')} alt="Arugam Bay" />
        <div className="dest-badge">Arugam Bay</div>
      </section>

      {/* Main Content Section */}
      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img src={require('../../img/arugam bay 2.webp')} alt="Arugam Bay beach" />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Discover Arugam Bay</h1>
              <p className="dest-description">
                A world-famous beach destination known for surfing, golden sandy shores, and a relaxed coastal atmosphere on Sri Lanka's east coast.
              </p>
              
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Secure and well-planned travel coverage
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Custom surf and beach holiday options
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Easy, relaxed, and worry-free beach travel
                </li>
              </ul>

              <div className="dest-meta">
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Land Trip</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>2 Days</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="currentColor" strokeWidth="2"/>
                    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Surfing</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Arugam Bay is a world-renowned beach destination located on Sri Lanka's southeast coast, famous for its laid-back atmosphere, golden sandy beaches, and excellent surf conditions. Originally a small fishing village, Arugam Bay has grown into an international surfing hotspot, attracting surfers from around the world, especially during the peak season from April to October.
              </p>
              <p className="dest-bottom-text">
                The area is home to several well-known surf breaks such as Main Point, Whiskey Point, and Peanut Farm, making it ideal for both beginners and experienced surfers. Beyond surfing, visitors can enjoy stunning sunsets, calm lagoons, nearby wildlife sanctuaries, and cultural sites, offering a perfect blend of adventure, relaxation, and natural beauty.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img src={require('../../img/arugam bay 3.webp')} alt="Arugam Bay sunset" />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img src={require('../../img/arugam bay 4.webp')} alt="Ceylon D Tour Arugam Bay experience" />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour offers carefully curated Arugam Bay travel experiences designed for comfort, safety, and unforgettable coastal adventures. Our tour packages include reliable transportation, flexible itineraries, accommodation assistance, and guided visits to popular surf spots, beaches, and nearby attractions such as Kumana National Park, Pottuvil Lagoon, and ancient temples. Whether you're seeking an exciting surf holiday, a peaceful beach escape, or a mix of nature and culture, Ceylon D Tour ensures a smooth and personalized journey, allowing you to experience the best of Arugam Bay at your own pace.
              </p>
            </div>
          </div>

          {/* Destination Suggestions */}
          <DestinationSuggestions 
            currentDestination="ArugamBay"
            suggestions={getRandomSuggestions('/places/arugam-bay', 4)}
          />
        </div> {/* End of dest-container */}
      </section>
      </div>
    </div>
  );
};

export default ArugamBay;

